import { DependencyList, useLayoutEffect, useRef, useState } from 'react';

const EDGE_MARGIN = 16;

export function useEdgeAwarePanelOffset(
  isOpen: boolean,
  deps: DependencyList = []
) {
  const panelRef = useRef<HTMLDivElement>(null);
  const [offsetX, setOffsetX] = useState(0);

  useLayoutEffect(() => {
    const el = panelRef.current;
    if (!isOpen || !el) {
      setOffsetX(0);
      return undefined;
    }

    const recalculate = () => {
      el.style.transform = '';
      const rect = el.getBoundingClientRect();

      let nextOffset = 0;
      if (rect.right > window.innerWidth - EDGE_MARGIN) {
        nextOffset = window.innerWidth - EDGE_MARGIN - rect.right;
      } else if (rect.left < EDGE_MARGIN) {
        nextOffset = EDGE_MARGIN - rect.left;
      }

      setOffsetX(nextOffset);
    };

    recalculate();
    window.addEventListener('resize', recalculate);
    return () => window.removeEventListener('resize', recalculate);
  }, [isOpen, ...deps]);

  return { panelRef, offsetX };
}
